<script setup lang="ts">
import { Refresh } from "@element-plus/icons-vue";

const emit = defineEmits<{
  (e: "click"): void;
}>();
</script>

<template>
  <el-button
    class="refreshButton"
    :icon="Refresh"
    title="Click to refresh"
    @click="emit('click')"
  >
    Refresh
  </el-button>
</template>

<style lang="less">
.refreshButton {
  // background-color: var(--el-color-primary);
  //color: white;
  font-size: 15px;
}
.refreshButton:hover {
  background-color: var(--el-color-primary-light-3);
  color: white;
}
</style>
